const styles = theme => ({
  paper: {
    minWidth: 300,
    display: 'inline-block',
    marginRight: 20,
    marginBottom: 20,
    verticalAlign: 'top',
  },
  clickable: {
    cursor: 'pointer',
  },
  equipment: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  equipmentLink: {
    '&:first-child': {
      paddingLeft: 30,
      textAlign: 'left',
      justifyContent: 'left',
    },
  },
});

export default styles;
